import { render, staticRenderFns } from "./CourseInfoModal.html?vue&type=template&id=83e7b746&scoped=true&"
import script from "./CourseInfoModal.vue?vue&type=script&lang=js&"
export * from "./CourseInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoModal.scss?vue&type=style&index=0&id=83e7b746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e7b746",
  null
  
)

export default component.exports